import React from 'react';
import { string } from 'prop-types';
import { VSpacer } from 'components/Spacer/Spacer';
import Typography from 'components/Typography/Typography';

/**
 * Failure state for the split session-data APIs.
 *
 * Naming the leg tells QA and support which endpoint to look at and gives away
 * nothing sensitive. The server's own `error_message` is never rendered - it can
 * carry the DB schema and the client's internal name, e.g.
 * `relation "scm_<client>.store_store_planogram_mapping" does not exist`.
 * That text goes to the console and Bugsnag only.
 */
const MESSAGE_BY_LEG = {
  images: 'Could not load shelf images.',
  misc: 'Could not load session details.',
  variants: 'Could not load SKU data.'
};

const FALLBACK = 'Could not load this session.';
const REMEDY = 'Please try again later or contact your administrator.';

const SessionDataError = ({ failedLeg }) => (
  <div style={{ minHeight: '250px' }}>
    <VSpacer amount={30} />
    <Typography weight="400" color="light25" align="center">
      {`${MESSAGE_BY_LEG[failedLeg] || FALLBACK} ${REMEDY}`}
    </Typography>
  </div>
);

SessionDataError.propTypes = {
  failedLeg: string
};

SessionDataError.defaultProps = {
  failedLeg: null
};

export default SessionDataError;
